// this is a dummy file. if it doesn't exist Metro will throw an error during bundling because there's no default _layout.tsx file
import { Slot, useGlobalSearchParams } from 'expo-router'

import { FosterFormProvider } from '@/components/fosters/FosterFormContext'

const FosterIdLayout = () => {
  // useGlobalSearchParams is required here (not useLocalSearchParams) because
  // in the SplitView on web, local params may not re-render when navigating
  // between fosters. Global params update reliably, ensuring the key={fosterId}
  // prop causes a proper remount of the provider + form + autosave pipeline.
  const { id: fosterId } = useGlobalSearchParams<{ id: string }>()

  return (
    <FosterFormProvider fosterId={fosterId} key={fosterId}>
      <Slot />
    </FosterFormProvider>
  )
}

export default FosterIdLayout
